import { useState } from 'react';

export default function Navbar({ isScrolled }: { isScrolled: boolean }) {
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  const scrollToSection = (id: string) => {
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
      setIsMenuOpen(false);
    }
  };

  return (
    <nav
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        isScrolled ? 'bg-white shadow-lg' : 'bg-transparent'
      }`}
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 py-3 sm:py-4">
        <div className="flex items-center justify-between">
          <img
            src={`${__BASE_PATH__}logo.webp?ver=${__READDY_VERSION_ID__}`}
            alt="Rancho da Verdura"
            className="h-12 sm:h-16 md:h-18 w-auto cursor-pointer"
            onClick={() => scrollToSection('home')}
          />

          <div className="hidden lg:flex items-center gap-6 xl:gap-8">
            <button
              onClick={() => scrollToSection('home')}
              className={`font-medium transition-colors whitespace-nowrap cursor-pointer text-sm xl:text-base ${
                isScrolled ? 'text-[#2d5016] hover:text-[#9bc53d]' : 'text-white hover:text-[#9bc53d]'
              }`}
            >
              Início
            </button>
            <button
              onClick={() => scrollToSection('about')}
              className={`font-medium transition-colors whitespace-nowrap cursor-pointer text-sm xl:text-base ${
                isScrolled ? 'text-[#2d5016] hover:text-[#9bc53d]' : 'text-white hover:text-[#9bc53d]'
              }`}
            >
              Sobre Nós
            </button>
            <button
              onClick={() => scrollToSection('products')}
              className={`font-medium transition-colors whitespace-nowrap cursor-pointer text-sm xl:text-base ${
                isScrolled ? 'text-[#2d5016] hover:text-[#9bc53d]' : 'text-white hover:text-[#9bc53d]'
              }`}
            >
              Produtos
            </button>
            <button
              onClick={() => scrollToSection('gallery')}
              className={`font-medium transition-colors whitespace-nowrap cursor-pointer text-sm xl:text-base ${
                isScrolled ? 'text-[#2d5016] hover:text-[#9bc53d]' : 'text-white hover:text-[#9bc53d]'
              }`}
            >
              Galeria
            </button>
            <button
              onClick={() => scrollToSection('reviews')}
              className={`font-medium transition-colors whitespace-nowrap cursor-pointer text-sm xl:text-base ${
                isScrolled ? 'text-[#2d5016] hover:text-[#9bc53d]' : 'text-white hover:text-[#9bc53d]'
              }`}
            >
              Nossos Clientes
            </button>
            <button
              onClick={() => scrollToSection('contact')}
              className={`font-medium transition-colors whitespace-nowrap cursor-pointer text-sm xl:text-base ${
                isScrolled ? 'text-[#2d5016] hover:text-[#9bc53d]' : 'text-white hover:text-[#9bc53d]'
              }`}
            >
              Contato
            </button>
            <a
              href="https://wa.me/5519993773158"
              target="_blank"
              rel="noopener noreferrer"
              className="bg-[#9bc53d] text-white px-4 xl:px-6 py-2 rounded-full font-semibold hover:bg-[#2d5016] transition-all duration-300 whitespace-nowrap cursor-pointer text-sm xl:text-base"
            >
              Fale Conosco
            </a>
          </div>

          <button
            onClick={() => setIsMenuOpen(!isMenuOpen)}
            className={`lg:hidden w-10 h-10 flex items-center justify-center cursor-pointer ${
              isScrolled ? 'text-[#2d5016]' : 'text-white'
            }`}
          >
            <i className={`text-2xl ${isMenuOpen ? 'ri-close-line' : 'ri-menu-line'}`}></i>
          </button>
        </div>

        {isMenuOpen && (
          <div className="lg:hidden mt-4 py-4 bg-white rounded-lg shadow-lg">
            <button
              onClick={() => scrollToSection('home')}
              className="block w-full text-left px-6 py-3 text-[#2d5016] hover:bg-gray-50 transition-colors whitespace-nowrap cursor-pointer"
            >
              Início
            </button>
            <button
              onClick={() => scrollToSection('about')}
              className="block w-full text-left px-6 py-3 text-[#2d5016] hover:bg-gray-50 transition-colors whitespace-nowrap cursor-pointer"
            >
              Sobre Nós
            </button>
            <button
              onClick={() => scrollToSection('products')}
              className="block w-full text-left px-6 py-3 text-[#2d5016] hover:bg-gray-50 transition-colors whitespace-nowrap cursor-pointer"
            >
              Produtos
            </button>
            <button
              onClick={() => scrollToSection('gallery')}
              className="block w-full text-left px-6 py-3 text-[#2d5016] hover:bg-gray-50 transition-colors whitespace-nowrap cursor-pointer"
            >
              Galeria
            </button>
            <button
              onClick={() => scrollToSection('reviews')}
              className="block w-full text-left px-6 py-3 text-[#2d5016] hover:bg-gray-50 transition-colors whitespace-nowrap cursor-pointer"
            >
              Nossos Clientes
            </button>
            <button
              onClick={() => scrollToSection('contact')}
              className="block w-full text-left px-6 py-3 text-[#2d5016] hover:bg-gray-50 transition-colors whitespace-nowrap cursor-pointer"
            >
              Contato
            </button>
            <a
              href="https://wa.me/5519993773158"
              target="_blank"
              rel="noopener noreferrer"
              className="block mx-6 mt-2 text-center bg-[#9bc53d] text-white px-6 py-3 rounded-full font-semibold hover:bg-[#2d5016] transition-all duration-300 whitespace-nowrap cursor-pointer"
            >
              Fale Conosco
            </a>
          </div>
        )}
      </div>
    </nav>
  );
}
